import api from './api'
import getLocale from '../locale'
import { CustomerService } from './CustomerService'

/**
 *
 * @param {*} payload
 * @param {string[]} noAuthRoutes
 */
const getInitialState = async ({ url }, noAuthRe) => {
	let user = null
	let locale = {}
	let version = null
	let company = { style: { primary_color: '#182447' } }
	const language = navigator.language || navigator.userLanguage
	const lang = (language === 'fr-FR')
		? language
		: 'pt-BR';

	; ({ locale } = await getLocale(lang))
	// }

	// if (url !== '/landing-page' && url !== '/dev') {
	// 	await api.get('/company-config').then((res) => {
	// 		company = res.data
	// 	})
	// }

	try {
		// if (window.location.pathname.includes('dev')) {
		// 	return ({ data: { customer: user } } = await api.get('/me'))
		// }
		if (!noAuthRe.exec(url)) {
			const data = await CustomerService.getMe()
			
			// Valida se data é um objeto válido
			if (data && typeof data === 'object') {
				user = data.customer || null
				company = data.company || company
			} else {
				console.error('Invalid response from getMe:', data)
				user = null
			}
		}
	} catch (e) {
		console.error('Error in getInitialState:', e)
		user = null
	}

	return {
		lang,
		user,
		locale,
		version,
		url,
		company,
		language,
		loadingAppState: false
	}
}

export default getInitialState
